import { getInStoreOrderDetail, getOrderDetail } from "../services/orderService";
import { format, MathUtils } from "./index";
import { getDictionary } from "../services/siteService";
import getSiteInfo from "./getSiteInfo";
import { dictTypes, InstantCode, printPdf, ProductType } from "./lynkco-constants";

export const getLang = lang => {
  return lang.indexOf("-") > -1 ? lang.split("-")[0].toUpperCase() : lang.toUpperCase();
};
export const getOrderType = subType => {
  switch (subType) {
    case "ORDERSUBTYPE01":
      return "gears";
    case "ORDERSUBTYPE02":
      return "presale";
    case "ORDERSUBTYPE03":
      return "monthToMonth";
    case "ORDERSUBTYPE04":
      return "longTerm";
    case "ORDERSUBTYPE05":
      return "buyACarLoan";
    case "ORDERSUBTYPE06":
      return "buyACarCash";
    default:
      return;
  }
};
export const getGearOrderType = deliveryMethod => {
  switch (deliveryMethod) {
    case InstantCode:
      return printPdf.gearsSale;
    default:
      return printPdf.gearConfirm;
  }
};
export const filterZeroPrice = (list = [], lang) => {
  let zeroValue = MathUtils.priceFormat(0, lang);
  let arrNew = list.filter(item => item.value !== zeroValue);
  return arrNew;
};
export const filterArrValue = (list = []) => {
  let arrNew = list.filter(item => item?.value || item?.orderItems?.length);
  return arrNew;
};
export const getGearOrderDetailValue = ({ detailsItem, res }) => {
  let suborders = res?.suborders ? res?.suborders : [];
  let language = res?.country ? `${res?.language}-${res?.country}` : res?.language;
  let orderItems = [];
  suborders.map(suborder => {
    suborder.orderItems.map(orderItem => {
      var skuAttributeList = orderItem.skuAttributeList;
      let _details = skuAttributeList.map(x => ({
        label: x.label,
        value: x.value
      }));
      _details = [..._details, ...getGearOrderDetailLabelsFieldValue(detailsItem, suborder, orderItem)];
      orderItems.push({
        image: {
          src: orderItem.image
        },
        name: orderItem.spuName,
        details: _details,
        priceFormatted: MathUtils.priceFormat(orderItem.price, language),
        discountPriceFormatted: orderItem.price === orderItem.paymentUnitAmount ? null : MathUtils.priceFormat(orderItem.paymentUnitAmount, language)
      });
      return null;
    });
    return null;
  });
  return orderItems;
};
export const getPdpOrderDetailValue = ({ detailsItem = [], res, yesValue }) => {
  let suborders = res?.suborders ? res?.suborders : [];
  let orderExtraData = res?.orderExtraData ? res?.orderExtraData : null;
  let orderImage = "";
  let itemDetails = [];
  suborders.map(suborder => {
    suborder.orderItems.map(orderItem => {
      if (orderItem?.productType === ProductType.vehicle) {
        orderImage = { src: orderItem?.image };
      }
      return null;
    });
    return null;
  });
  detailsItem.forEach(item => {
    let details = {};
    switch (item?.fields?.key?.value) {
      case "orgName":
        if (res[item?.fields?.key?.value]) {
          details = {
            label: item?.fields?.phrase?.value,
            value: res[item?.fields?.key?.value]
          };
          itemDetails.push(details);
        }
        break;
      default:
        break;
    }
    let value = orderExtraData[item?.fields?.key?.value] === "1" ? yesValue : orderExtraData[item?.fields?.key?.value];
    if (value && value !== "0") {
      details = {
        label: item?.fields?.phrase?.value,
        value: value
      };
      itemDetails.push(details);
    }
  });
  let orderItems = [
    {
      image: orderImage,
      name: orderExtraData?.model,
      details: itemDetails
    }
  ];
  return orderItems;
};

export const presalesOrderDetails = async parameter => {
  const { orderId, membership, labels, lang, inStore } = parameter;
  let orderData = [];
  let orderDetail = null;
  if (inStore) {
    orderDetail = await getInStoreOrderDetail(orderId);
  } else {
    orderDetail = await getOrderDetail(orderId);
  }
  const siteInfo = await getSiteInfo();
  (labels || []).forEach(label => {
    let labelKey = (label && label.fields && label.fields.key.value) || "";
    let labelValue = "";
    labelValue = getOrderFieldValue(labelKey, orderDetail, lang, null, siteInfo.dateFormat);
    if (labelKey === "memberShip") {
      labelValue = membership;
    }
    orderData.push({
      label: label.fields.phrase.value,
      value: labelValue
    });
  });
  return { orderDetail, orderData };
};
export const gearOrderDetails = async parameter => {
  const { orderId, lang, orderFields, inStore } = parameter;
  let _orderData = [],
    itemList = [],
    shippingAdressLineValue = [],
    contactInfoLineValue = [];
  let orderDetail = null;
  if (inStore) {
    orderDetail = await getInStoreOrderDetail(orderId);
  } else {
    orderDetail = await getOrderDetail(orderId);
  }
  const siteInfo = await getSiteInfo();
  if (orderDetail) {
    // receiverInfo
    const delivermethods = await getDictionary(dictTypes.deliveryMethod);
    if (orderDetail.shippingInfo) {
      let info = orderDetail.shippingInfo;
      shippingAdressLineValue = [`${info.firstName || ""} ${info.lastName || ""}`, `${info.address1 || ""} ${info.address2 || ""}`, `${info.postCode || ""} ${info.city || ""}`];
      contactInfoLineValue = [info.email, `${info.mobileCountryCode || ""}${info.mobile || ""}`];
    }
    orderDetail.suborders.forEach(item => {
      item.orderItems.forEach(orderItem => {
        itemList.push({ name: orderItem.spuName, quantity: orderItem.qty });
      });
    });
    orderFields.forEach(label => {
      let labelKey = (label && label.fields && label.fields.key.value) || "";
      let labelValue = "";
      labelValue = getGearOrderFieldValue(labelKey, orderDetail, lang, delivermethods, siteInfo.dateFormat);
      _orderData.push({
        title: label.fields.phrase.value,
        value: labelValue
      });
    });
  }
  return {
    orderDetail,
    itemList,
    shippingAdressLineValue,
    contactInfoLineValue,
    _orderData
  };
};
export const getGearOrderDetailLabelsFieldValue = (gearOrderDetailLabels, details, detail) => {
  return gearOrderDetailLabels.map(gearOrderDetail => {
    let gearOrderDetailValue = "";
    let key = gearOrderDetail?.fields.key.value;
    gearOrderDetailValue = detail[key] || "";
    switch (key) {
      case "qty":
        gearOrderDetailValue = gearOrderDetailValue.toString();
        break;
      case "storeName":
        gearOrderDetailValue = details.storeName || "";
        break;
      default:
    }
    return {
      label: gearOrderDetail?.fields.phrase.value,
      value: gearOrderDetailValue
    };
  });
};
export const getOrderFieldValue = (key, data, lang, membershipLabels, dateFormat) => {
  let labelValue = data[key] || "";
  let language = data?.country ? `${data?.language}-${data?.country}` : data?.language;
  let subordersOrderItems = data.suborders[0].orderItems[0];
  let skuAttributeList = subordersOrderItems.skuAttributeList;
  let spuAttributeList = subordersOrderItems.spuAttributeList;
  switch (key) {
    case "orderDate":
      labelValue = format(data.orderDate, dateFormat);
      break;
    case "cardNo":
      labelValue = labelValue ? labelValue : "";
      break;
    case "color":
    case "engine":
      if (skuAttributeList.length) {
        skuAttributeList.forEach(item => {
          if (item.defaultLanguageLabel.toLowerCase() === key) {
            labelValue = item.value;
          }
        });
      }
      break;
    case "Model":
      if (spuAttributeList) {
        spuAttributeList.forEach(item => {
          if (item.defaultLanguageLabel === key) {
            labelValue = item.value;
          }
        });
      }
      break;
    case "orderDeposit":
      labelValue = MathUtils.priceFormat(data.deposit, language);
      break;
    case "memberShip":
      return membershipLabels?.filter(x => x.dicCode === data.memberShip)[0]?.languages[getLang(language)]?.dicName;
    case "spuName":
      return subordersOrderItems?.spuName;
    case "gearProductData":
      labelValue = "html";
      break;
    default:
      break;
  }
  return labelValue;
};
export const getGearOrderFieldValue = (key, data, lang, delivermethods, dateFormat) => {
  let labelValue = data[key] || "";
  let language = data?.country ? `${data?.language}-${data?.country}` : data?.language;
  switch (key) {
    case "subTotal":
    case "shipping":
    case "grandTotal":
      labelValue = MathUtils.priceFormat(labelValue || 0, language);
      break;
    case "orderDeposit":
      labelValue = MathUtils.priceFormat(data.deposit, language);
      break;
    case "orderDate":
      labelValue = format(data.orderDate, dateFormat);
      break;
    case "deliveryMethod":
      labelValue = delivermethods?.filter(x => x.dicCode === labelValue)[0]?.languages[getLang(language)]?.dicName;
      break;
    case "cardNo":
      labelValue = labelValue ? labelValue : "";
      break;
    case "billingInfo":
    case "shippingInfo":
      labelValue = `${labelValue.firstName || ""} ${labelValue.lastName || ""}<br/>${labelValue.address1 || ""} ${labelValue.address2 || ""}<br/>${labelValue.postCode || ""} ${labelValue.city || ""}<br/>${labelValue.country || ""} `;
      break;
    case "contactInfo":
      let info = data.shippingInfo;
      labelValue = `${info.email || ""}<br/>${info.mobileCountryCode || ""}${info.mobile || ""}`;
      break;
    case "gearProductData":
      labelValue = "html";
      break;
    case "trackingNumber":
      (data.logisticInfo || []).map(item => {
        labelValue += `${item.shipmentNo}<br/>`;
      });
      break;
    default:
      break;
  }
  return labelValue;
};
export const getPdpOrderFieldValue = (key, data, lang, delivermethods, dateFormat, membershipLabels) => {
  if (!data) return;
  let labelValue = data[key] || "";
  let language = data?.country ? `${data?.language}-${data?.country}` : data?.language;
  switch (key) {
    case "subTotal":
    case "shipping":
    case "grandTotal":
      labelValue = MathUtils.priceFormat(labelValue || 0, language);
      break;
    case "orderDeposit":
      labelValue = MathUtils.priceFormat(data.deposit || 0, language);
      break;
    case "orderDate":
      labelValue = format(data.orderDate, dateFormat);
      break;
    case "memberShip":
      labelValue = membershipLabels?.filter(x => x.dicCode === data.memberShip)[0]?.languages[getLang(language)]?.dicName;
      break;
    case "deliveryMethod":
      labelValue = delivermethods?.filter(x => x.dicCode === labelValue)[0]?.languages[getLang(language)]?.dicName;
      break;
    case "cardNo":
      labelValue = labelValue ? labelValue : "";
      break;
    case "color":
    case "engine":
    case "planName":
      labelValue = data?.orderExtraData ? data.orderExtraData[key] : "";
      break;
    case "billingInfo":
    case "shippingInfo":
      labelValue = `${labelValue.firstName || ""} ${labelValue.lastName || ""}<br/>${labelValue.address1 || ""} ${labelValue.address2 || ""}<br/>${labelValue.postCode || ""} ${labelValue.city || ""}<br/>${labelValue.country || ""} `;
      break;
    case "contactInfo":
      let info = data.shippingInfo;
      labelValue = `${info.email || ""}<br/>${info.mobileCountryCode || ""}${info.mobile || ""}`;
      break;
    case "pdpProductData":
      labelValue = "html";
      break;
    case "trackingNumber":
      (data.logisticInfo || []).map(item => {
        labelValue += `${item.shipmentNo}<br/>`;
      });
    case "totalMonthlyFee":
    case "finalPayment":
      labelValue = MathUtils.priceFormat(data.orderExtraData[key] || 0, language);
      break;
    case "totalPayedInclVAT":
      let num = data?.orderExtraData?.dueTodayFee + data?.orderExtraData?.finalPayment || 0;
      labelValue = MathUtils.priceFormat(num, language);
      break;
    case "totalPayment":
      labelValue = data?.monthlyPaymentInformation ? MathUtils.priceFormat(data?.monthlyPaymentInformation[key] || 0, language) : null;
      break;
    default:
      break;
  }
  return labelValue;
};
